module.exports = __webpack_public_path__ + "img/icon-type-used.fde49ecf.png";